import type * as GraphQLTypes from '../../../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CustomerPackagesQueryVariables = GraphQLTypes.Exact<{
  customerIds?: GraphQLTypes.InputMaybe<Array<GraphQLTypes.Scalars['String']> | GraphQLTypes.Scalars['String']>;
}>;


export type CustomerPackagesQueryResult = (
  { __typename?: 'Query' }
  & { getPackages: Array<(
    { __typename?: 'Package' }
    & Pick<GraphQLTypes.Package, 'id' | 'packageName' | 'netTotal' | 'createdAt'>
    & { createdBy?: GraphQLTypes.Maybe<(
      { __typename?: 'Admin' }
      & Pick<GraphQLTypes.Admin, 'id' | 'firstName' | 'lastName'>
    )>, customerPayment?: GraphQLTypes.Maybe<(
      { __typename?: 'PackagePayment' }
      & Pick<GraphQLTypes.PackagePayment, 'id'>
      & { total?: GraphQLTypes.Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<GraphQLTypes.PaymentType, 'amount'>
      )> }
    )> }
  )> }
);


export const CustomerPackagesDocument = /*#__PURE__*/ gql`
    query customerPackages($customerIds: [String!]) {
  getPackages(customerIds: $customerIds) {
    id
    packageName
    netTotal
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
    customerPayment {
      id
      total {
        amount
      }
    }
  }
}
    `;

/**
 * __useCustomerPackagesQuery__
 *
 * To run a query within a React component, call `useCustomerPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerPackagesQuery({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useCustomerPackagesQuery(baseOptions?: Apollo.QueryHookOptions<CustomerPackagesQueryResult, CustomerPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerPackagesQueryResult, CustomerPackagesQueryVariables>(CustomerPackagesDocument, options);
      }
export function useCustomerPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerPackagesQueryResult, CustomerPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerPackagesQueryResult, CustomerPackagesQueryVariables>(CustomerPackagesDocument, options);
        }
export type CustomerPackagesQueryHookResult = ReturnType<typeof useCustomerPackagesQuery>;
export type CustomerPackagesLazyQueryHookResult = ReturnType<typeof useCustomerPackagesLazyQuery>;